import axios from "@/lib/axios";
import { useMutation, useQuery } from "@tanstack/vue-query";

interface Props {
  immediate?: boolean;
}

interface UpdateParams {
  id: number;
  bankId: number;
  accountNumber: string;
  rfc: string;
  paymentType: string;
  account_id: string;
}

const getBankAccount = async () => {
  const { data } = await axios.get("/api/internal/bank-accounts");

  return data;
};

const updateBankAccount = async (updateParams: UpdateParams) => {
  const { data } = await axios.put(
    `/api/internal/bank-accounts/${updateParams.id}`,
    updateParams,
  );

  return data;
};

const deleteBankAccount = async (id: number) => {
  const { data } = await axios.delete(`/api/internal/bank-accounts/${id}`);

  return data;
};

const restoreBankAccount = async (id: number) => {
  const { data } = await axios.post(
    `/api/internal/bank-accounts/${id}/restore`,
  );

  return data;
};

const useBankAccount = (props: Props) => {
  const { immediate = true } = props;

  const { data, isLoading, refetch } = useQuery(
    ["bank-account"],
    getBankAccount,
    {
      enabled: immediate,
    },
  );

  const updateBankAccountMutation = useMutation((updateParams: UpdateParams) =>
    updateBankAccount(updateParams),
  );

  const deleteBankAccountMutation = useMutation((id: number) =>
    deleteBankAccount(id),
  );

  const restoreBankAccountMutation = useMutation((id: number) =>
    restoreBankAccount(id),
  );

  return {
    data,
    isLoading,
    refetch,
    updateBankAccount: updateBankAccountMutation,
    deleteBankAccount: deleteBankAccountMutation,
    restoreBankAccount: restoreBankAccountMutation,
  };
};

export default useBankAccount;
